// 引入数据配置文件
import FormConfig from "./formConfig.js";
import { fun_PostAction } from "@/api/index";
import "../../../../utils/security.js";
export default {
  data() {
    return {
      // 表单对象
      form: {
        ymm: null, // 原密码
        yhmm: null, // 新密码
        yhmmqr: null  // 确认密码
      },
      // 表单对象
      request: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        ymm: null, // 原密码
        yhmm: null, // 新密码
        yhmmqr: null  // 确认密码
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      key: null, // 加密key
    };
  },
  // 模板编译完成
  mounted() {
    // 调用获取参数方法
    this.fun_GetRSAKey();
  },
  // 自定义方法
  methods: {
    /**
     * 获取参数接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.request.exponent = data.exponent;
          // 获取modulus
          this.request.modulus = data.modulus;
        }
      });
    },
    /**
     * @description 保存
     * @author
     */
    fun_Save() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(this.request.exponent,"", this.request.modulus);
          // 遍历加密用户名、密码、验证码
          for (let e in this.form) {
            this.request[e] = window.RSAUtils.encryptedString(this.key, this.form[e]);
          }
          // 提交
          this.fun_Submit();
        } else {
          return false;
        }
      });
    },
    /**
     * 提交
     */
    fun_Submit() {
      try {
        // 打开loading
        this.loading = true;
        // 执行获取列表接口
        fun_PostAction("/loginPassword/loginPasswordUpdate", {
          ...this.request
        }).then(res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 提示，并清除选中数据
            this.$alert(msg, "warning").then(() => {
              // 删除存储
              this.resetSetItem("flag", "");
              // 跳转工作台
              this.$router.push({path: "/home"});
            });
          } else {
            // 请求失败的场景
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
  }
};
